import { defineStore } from 'pinia';
import { estonianLicenseLocales } from '~/config/constants.config';
import { createPopulateString, parseCollectionData } from '~/utils/strapiComponents/addStrapiData';
import { useStoreRoot } from '../abstract/root';
import { strapi } from '../transport/strapi';
import type { ILanguageMenuData, ILanguageMenuStrapiResponse } from '~/types/language';

export const useStoreLanguages = defineStore('languages', {
  state: () => ({
    data: [] as ILanguageMenuData[],
    requestPromise: null as Promise<ILanguageMenuStrapiResponse> | null,
  }),

  getters: {
    activeList(state): ILanguageMenuData[] {
      if (useStoreRoot().isEstonianLicense) {
        return state.data.filter((item) => estonianLicenseLocales.includes(item.langCode));
      }
      return state.data.filter((item) => !estonianLicenseLocales.includes(item.langCode));
    },
  },

  actions: {
    async loadLanguages() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['langImg']);

        this.requestPromise = strapi()
          .get('language-menus', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        const parsedData = parseCollectionData(response.data);
        const filteredState = this.data.filter(
          (item) => !parsedData.find(({ id }) => id && id === item.id)
        );

        this.data = [...filteredState, ...parsedData].sort((a, b) => a.position - b.position);

        return true;
      } else {
        return false;
      }
    },
  },
});
